<template>
  <main class="home">
      <div v-html="content_text">{{ content_text }}</div>
  </main>
</template>

<script>
// @ is an alias to /src
import Logo from "@/components/Logo.vue";

export default {
  name: 'home',
  components: {
    Logo,
  },
    props: {
        content_text: {
            type: String,
                    required: false
        },
        content_title: {
            type: String,
                    required: false
        },
        template: {
            type: String,
                    required: false
        },
        services: {
            type: Array,
                    required: false
        }
    },
};
</script>
